import type { SVGProps } from 'react';

import imageUrl from './attend_event_img.svg?url';

export function AttendEvent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 88" {...props}>
      <image href={imageUrl} width="97" height="88" />
    </svg>
  );
}
